import IntroPopUp from "components/intro-popup/intro-popup";

export default IntroPopUp;